module.exports = __webpack_public_path__ + "img/design.9c832bda.png";